export const environment = {
  production: false,
  apiUrl: 'https://backend-staging.tmdigital.ag',
  apiGatewayUrl: 'https://backend-monitoring-staging.tmdigital.ag',
  tmPlatformUrl: 'https://app-staging.tmdigital.ag',
  tmMonitoringUrl: 'https://risk-staging.tmdigital.ag',
  sentry: {
    dsn: 'https://f779f6f900834b6a9c43e4249af06004@o1059209.ingest.sentry.io/6215667',
    environment: 'development',
  },
  amplitude: {
    apiKey: '556ba086d657687a5603c27a4ddaed17',
  },
};
